var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-sorting u-flex u-items-center"},[(_vm.sortingDirection === 'asc')?_c('i',{staticClass:"material-icons sort"},[_vm._v("")]):_c('i',{staticClass:"material-icons sort"},[_vm._v("")])])
}
var staticRenderFns = []

export { render, staticRenderFns }